import { lazy } from "react";

const routes = [
  {
    path: "/pages",
    element: lazy(() => import("../../pages/ModulePersonalization/Pages")),
  },
  {
    path: "/pages/create",
    element: lazy(
      () => import("../../pages/ModulePersonalization/Pages/create-editPages"),
    ),
  },
  {
    path: "/pages/edit/:id",
    element: lazy(
      () => import("../../pages/ModulePersonalization/Pages/create-editPages"),
    ),
  },
];

export default routes;
